import DataList from "../../../../component/DataList";

export default function StatHistory() {
  return (
    <>
      <DataList
        url={"/erp/production-tasks/confirm-history"}
        descriptions={[
          {
            fieldName: "produceOrderSerialNumber",
            fieldShowName: "订单单号",
            width: 120,
          },
          {
            fieldName: "workshopId",
            fieldShowName: "车间",
            width: 100,
            inputType: 6,
            dictionary: "erp_workshop",
          },
          {
            fieldName: "procedureId",
            fieldShowName: "工序",
            width: 100,
            inputType: 6,
            dictionary: "erp_procedure",
          },
          {
            fieldName: "radId",
            fieldShowName: "产品名称",
            width: 100,
            inputType: 6,
            dictionary: "rad_sku",
          },
          {
            fieldName: "userId",
            fieldShowName: "生产人员",
            width: 80,
            inputType: 8,
            dictionary: "base_staff_all",
          },
          {
            fieldName: "date",
            fieldShowName: "生产日期",
            width: 100,
            inputType: 4,
            format: "yyyy-MM-dd HH:mm",
          },
          {
            fieldName: "passCount",
            fieldShowName: "通过数量",
            width: 50,
            inputType: 2,
          },
          {
            fieldName: "rejectCount",
            fieldShowName: "打回数量",
            width: 50,
            inputType: 2,
          },
        ]}
      />
    </>
  );
}
